/**
 * Typography — DM Serif Display for headings (cookbook warmth),
 * Plus Jakarta Sans for body (geometric, warmer than Inter).
 */

export const typography = {
  fonts: {
    heading: '"DM Serif Display", Georgia, "Times New Roman", serif',
    body:    '"Plus Jakarta Sans", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    mono:    '"JetBrains Mono", "Fira Code", "Cascadia Code", monospace',
  },
  fontSizes: {
    xs:   '0.75rem',
    sm:   '0.8125rem',
    md:   '0.9375rem',
    lg:   '1.0625rem',
    xl:   '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
  },
  fontWeights: {
    normal:   400,
    medium:   500,
    semibold: 600,
    bold:     700,
  },
  lineHeights: {
    shorter: 1.2,
    short:   1.35,
    base:    1.5,
    tall:    1.625,
  },
};
